import { ComponentsProps } from "@mui/material";

const props: ComponentsProps = {
  MuiTextField: {
    variant: "filled",
    margin: "normal",
  },
};

export default props;
